import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Slider from '@material-ui/core/Slider';
import { Container } from './style';
import { Creators as ChatbotCreators } from '../../../store/ducks/chatbot';

const marks = [
  {
    value: 0,
    label: 'Ruim',
  },
  {
    value: 33,
    label: 'Mediano',
  },
  {
    value: 66,
    label: 'Bom',
  },
  {
    value: 100,
    label: 'Ótimo'
  },
];

class ServiceRatingSlider extends Component {

  onChange = (event, value) => {
    const mark = marks.find(mark => mark.value === value);

    this.props.setChatbotSaga(mark.label, this.props, true);
  }

  render() {
    return (
      <Container>
        <Slider
          defaultValue={33}
          step={null}
          onChangeCommitted={this.onChange}
          aria-labelledby="discrete-slider-custom"
          marks={marks}
          scale={() => ''}
        />
      </Container>
    );
  }

}

export default compose(connect(null, { ...ChatbotCreators }))(ServiceRatingSlider);